/**
 * Datos de ejemplo de la presentación (login y landing). Nombres, mesas y
 * montos son ficticios a propósito: es una vitrina, no datos del restaurante.
 */

export type TicketState = 'new' | 'prep' | 'ready';

export interface KitchenTicket {
  title: string;
  /** Segundos transcurridos al montar; el cronómetro sigue desde aquí. */
  seconds: number;
  state: TicketState;
  items: Array<[number, string]>;
  note?: string;
}

export const KITCHEN_TICKETS: KitchenTicket[] = [
  { title: 'Mesa 4', seconds: 252, state: 'prep', items: [[2, 'Tacos al pastor'], [1, 'Quesadilla de flor'], [1, 'Agua de horchata']], note: 'sin cebolla' },
  { title: 'Llevar #112', seconds: 48, state: 'new', items: [[3, 'Enchiladas suizas'], [1, 'Sopa de lima']] },
  { title: 'Mesa 9', seconds: 665, state: 'ready', items: [[1, 'Molcajete mixto'], [2, 'Cerveza clara']] },
  { title: 'Barra 2', seconds: 390, state: 'prep', items: [[2, 'Chilaquiles verdes'], [2, 'Café de olla']], note: 'crema aparte' },
  { title: 'Mesa 12', seconds: 80, state: 'new', items: [[4, 'Tostadas de tinga'], [1, 'Guacamole']] },
  { title: 'Mesa 6', seconds: 612, state: 'prep', items: [[1, 'Pozole rojo grande'], [1, 'Tostadas extra']] },
  { title: 'Llevar #113', seconds: 15, state: 'new', items: [[6, 'Tacos de suadero'], [2, 'Agua de jamaica']], note: 'salsa verde' },
];

export const TICKET_STATE_LABEL: Record<TicketState, string> = {
  new: 'Nuevo',
  prep: 'Preparando',
  ready: 'Listo para servir',
};

/** Más de 10 minutos sin estar listo: el cronómetro se pinta en rojo. */
export const LATE_AFTER_SECONDS = 600;

/** Colores de la franja de estado (mismos que la escena de cocina en CSS). */
export const TICKET_STATE_COLOR: Record<TicketState, string> = {
  new: '#2879a4',
  prep: '#b8860b',
  ready: '#3f7f22',
};

export const isLate = (ticket: KitchenTicket, seconds: number) =>
  ticket.state !== 'ready' && seconds >= LATE_AFTER_SECONDS;

/** 252 -> "04:12" */
export const mmss = (s: number) => {
  const m = Math.floor(s / 60);
  const r = s % 60;
  return `${m < 10 ? '0' : ''}${m}:${r < 10 ? '0' : ''}${r}`;
};

export type TableState = 'libre' | 'ocupada' | 'cuenta' | 'reservada';

export const INITIAL_TABLES: TableState[] = [
  'ocupada', 'ocupada', 'libre', 'cuenta', 'ocupada',
  'reservada', 'libre', 'ocupada', 'ocupada', 'libre',
  'ocupada', 'cuenta', 'libre', 'ocupada', 'ocupada',
];

export interface Bill {
  table: string;
  waiter: string;
  guests: number;
  time: string;
  folio: string;
  items: Array<[number, string, number]>;
}

export const BILLS: Bill[] = [
  { table: 'Mesa 7', waiter: 'Luis', guests: 2, time: '14:32', folio: 'A-01482', items: [[2, 'Tacos al pastor', 48], [1, 'Gringa de pastor', 75], [2, 'Agua de jamaica', 35]] },
  { table: 'Para llevar', waiter: 'Caja', guests: 1, time: '14:41', folio: 'A-01483', items: [[3, 'Enchiladas suizas', 129], [1, 'Sopa de lima', 85], [1, 'Agua de horchata', 35]] },
  { table: 'Mesa 12', waiter: 'Mariana', guests: 4, time: '14:58', folio: 'A-01484', items: [[1, 'Molcajete mixto', 389], [1, 'Guacamole', 120], [3, 'Cerveza clara', 55], [1, 'Flan napolitano', 65]] },
];

/** Los precios del menú ya traen IVA; el ticket lo desglosa al 16 %. */
export const IVA_RATE = 0.16;
